import { render, staticRenderFns } from "./ProductSubstituitionPage.vue?vue&type=template&id=d9fda8f0&"
import script from "./ProductSubstituitionPage.vue?vue&type=script&lang=js&"
export * from "./ProductSubstituitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports